var AnswerStatusFilter = React.createClass({
  propTypes: {
    onStatusChanged: React.PropTypes.func,
    selectedStatusCode: React.PropTypes.string.isRequired
  },
  getDefaultProps() {
    return {
      selectedStatusCode: ""
    }
  },
  statusChanged(statusCode) {
    if (this.props.onStatusChanged) {
      this.props.onStatusChanged(statusCode);
    }
  },
  render() {
    let items = [
      {value: "",  label: Labels.getLabel("All")},
      {value: "1", label: Labels.getLabel("Answered")},
      {value: "0", label: Labels.getLabel("Unanswered")}
    ];

    return (
      <BrowseFilter title={Labels.getLabel("Status")} ariaLabel="Answer Status Filter">
        <FilterLinkList
          items={items}
          selectedValue={this.props.selectedStatusCode}
          onClick={this.statusChanged} />
      </BrowseFilter>
    )
  }
});